
(() => {

    const elements = document.querySelectorAll('.ga-event')

    if(elements.length) {
        elements.forEach(element => {
            element.addEventListener('click', (e) => {
                let category = element.dataset.eventCategory
                let label = element.dataset.eventLabel

                /*dataLayer.push({
                    'event': 'GAEvent',
                    'eventCategory' : category,
                    'eventAction' : 'click',
                    'eventLabel' : label,
                    'eventValue' : 0
                });*/

                gtag('event', 'click', {
                    'event_category': category,
                    'event_label': label
                });

            })
        })
    }

})()
